export const userPreferencesKeys = {
  all: ['userPreferences'] as const,
  get: ({
    programId,
    userId,
  }: {
    programId: string | undefined;
    userId: string | undefined;
  }) => [...userPreferencesKeys.all, 'get', programId, userId] as const,
};
